"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const AttachFile_1 = tslib_1.__importDefault(require("@mui/icons-material/AttachFile"));
const SvgComponent_1 = tslib_1.__importDefault(require("./SvgComponent"));
function FileIcon({ size, text, disabled, component, ...rest }) {
    const htmlColor = disabled ? "#9E9E9E" : "#000000";
    const iconSize = size || "24px";
    const Component = component || SvgComponent_1.default;
    if (text) {
        const props = {
            htmlColor,
            iconSize,
            text,
            ...rest,
        };
        return react_1.default.createElement(Component, { ...props });
    }
    return react_1.default.createElement(AttachFile_1.default, { ...rest });
}
exports.default = FileIcon;
